import React from "react";
import InventoryValue from "./InventoryValue";

const MyStats = () => {
  const progress = 1; // Change this value to update the progress

  return (
    <div className="flex flex-col pb-32">
      <InventoryValue />
      <div className="gap-y-4 self-center bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36 w-96">
        <div className="flex justify-around items-center">
          <p className="font-extrabold">Private</p>
          <label className="relative inline-flex items-center cursor-pointer">
            <input type="checkbox" defaultValue="" className="sr-only peer" />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" />
          </label>
          <p className="text-white bg-pinkColor w-20 text-center py-3 px-2 rounded-lg font-extrabold ">
            Public
          </p>
        </div>
        <p>
          Your Portfolio is visible to the public, share it with your friends!
        </p>
        <div className="flex justify-around items-center mt-4 gap-x-2">
          <input
            type="text"
            defaultValue="https://dummyurl.com"
            className="border border-gray-300 rounded-lg p-2 w-2/3"
          />
          <button className="bg-pinkColor text-white py-2 px-4 rounded-lg">
            Copy
          </button>
          <button className="bg-pinkColor text-white py-2 px-4 rounded-lg">
            Share
          </button>
        </div>
      </div>

      <div className="gap-y-6 self-center bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36 w-96 md:w-10/12">
        <div className="flex font-extrabold justify-between items-center">
          <p>Total portfolio value:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total portfolio size:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total Collections Started:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total Collections Completed:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total Collections Completion:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total Profit on Amount Paid:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total Amount Paid:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
        <div className="flex font-extrabold justify-between items-center">
          <p>Total Items with Amount Paid Set:</p>
          <div>
            <p className="font-extrabold text-lg">$0.00</p>
            <p className="font-extrabold text-sm">($0.00)</p>
            <p className="font-extrabold text-sm">Last Day</p>
          </div>
        </div>
        <hr />
      </div>
      <InventoryValue title="Count" />
      <InventoryValue title="Amount Paid" />
      <InventoryValue title="Profit" />
      <div className="gap-y-4 self-center bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36 w-96 md:w-4/12">
        <div className="relative p-1 rounded-lg border border-slate-300">
          <div className="overflow-hidden h-6 text-xs flex rounded-lg bg-gray-200">
            <div
              style={{ width: `${progress}%` }}
              className="shadow-none flex flex-col text-center w-full whitespace-nowrap text-black justify-center bg-pinkColor"
            >
              {progress}%
            </div>
          </div>
        </div>
        <p>
          You're beating<span className="font-bold">0%</span>of Collectors
        </p>
        <p>
          Add <span className="font-bold">1</span> Card to hit
          <span className="font-bold">1%</span>
        </p>
        <div className="relative p-1 rounded-lg border border-slate-300">
          <div className="overflow-hidden h-6 text-xs flex rounded-lg bg-gray-200">
            <div
              style={{ width: `${progress}%` }}
              className="shadow-none flex flex-col text-center w-full whitespace-nowrap text-black justify-center bg-pinkColor"
            >
              {progress}%
            </div>
          </div>
        </div>
        <p>
          You're more valuable than<span className="font-bold">0%</span>of
          Collectors
        </p>
        <p>
          Add Cards to see how the value of your Collection compares to others
        </p>
      </div>
      <div className="gap-y-4 flex flex-col items-center justify-center self-center bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36 w-96 md:w-4/12">
        <h2 className="text-center">
          Your portfolio statistics were last updated:
        </h2>
        <p className="font-extrabold text-center">13 hours ago</p>
        <button className="focus:outline-none text-white bg-pinkColor hover:bg-red-800 focus:ring-4 focus:ring-red-300 rounded-lg text-sm font-semibold px-1 py-3 mb-2 dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-900 flex items-center justify-center w-3/12">
          Refresh
        </button>
      </div>

      <div className="gap-y-6 flex flex-col justify-center items-center self-center bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36 w-96 md:w-10/12">
        <p className="font-extrabold">Your Top Valuable Inventory Items
</p>
        <p>No data</p>
      </div>
      <div className="gap-y-6 flex flex-col justify-center items-center self-center bg-white border border-slate-300 mx-3 mt-4 rounded-lg p-4 md:mx-36 w-96 md:w-10/12">
        <p className="font-extrabold">Top 10 Most Completed Collections</p>
        <p>
          You need to start adding items to your inventory for collections to
          appear here.
        </p>
      </div>
    </div>
  );
};

export default MyStats;
